import React, { Component } from 'react';

export default class Name extends Component {
    render () {
        const { first, last } = this.props;
        return (
            <div className="user-name-box">
                <h1 className="user-name">{first} {last}</h1>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/header/Name.js